import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';

const useStyles = createUseStyles({
  screenReaderOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    clip: 'rect(0 0 0 0)',
  },
});

export default function ScreenReaderOnly(props) {
  const classes = useStyles();
  
  return (
    <span className={classes.screenReaderOnly}>
      {props.children}
    </span>
  );
}

ScreenReaderOnly.propTypes = {
  children: PropTypes.node.isRequired,
};
